/**
 * Custom JS by RoarTheme Agent
 * https://haloroar.ticksy.com
 * App: RT: Terms and Conditions Box
 */
document.addEventListener("DOMContentLoaded", () => {
  const configuration = {
    widgetSelector: ".rale-widget",
    links: {
      link: "link",
    },
  };

  const legalConfig = window?.roarJs?.LegalConfig?.metafields?.settings;
  if (!legalConfig || legalConfig.enabled !== "1") return;

  const { param } = legalConfig;
  if (!param || !param.links) return;

  const messageKey = "message";
  const errorKey = "error_message";

  const translations = {
    en: {
      [messageKey]: `I have read and agree to the {${configuration.links.link}} `,
      [errorKey]:
        "Please agree to the terms and conditions before making a purchase!",
      labels: {
        [configuration.links.link]: "terms and conditions",
      },
    },
    de: {
      [messageKey]: `Ich habe die {${configuration.links.link}} gelesen und erkläre mich mit diesen einverstanden`,
      [errorKey]:
        "Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen zu, bevor Sie einen Kauf tätigen!",
      labels: {
        [configuration.links.link]: "Allgemeinen Geschäftsbedingungen",
      },
    },
  };

  const locale = Shopify?.locale || "en";
  const localeConfig = translations[locale];

  if (localeConfig) {
    param[messageKey] = localeConfig[messageKey];
    param[errorKey] = localeConfig[errorKey];
    Object.entries(localeConfig.labels).forEach(([key, label]) => {
      if (param.links[key]) param.links[key].label = label;
    });
  }

  window.roarJs.LegalConfig.metafields.settings.param = param;

  document
    .querySelectorAll(configuration.widgetSelector)
    .forEach((el) => el.remove());
  window.roarJs.Legal.init();
});
